<template>
    <div>
    <div class="container mt-4" v-if="errortype">
      <div class="alert alert-danger">{{ errortype | translate('msg') }}</div>
    </div>
    <form @submit.prevent="emitSave" id="valuemappingAddEditDialog" class="scrollable-container">
      <h4 class="mb-4">{{ 'ADD' | translate }}</h4>

      <div class="form-group" id="valuemappingAddEditDialog-formGroup-product">
        <label>{{ 'Product' | translate }}</label>
        <input type="text"
               class="form-control form-control-sm"
               v-model="valuemapping.product"
               id="valuemappingAddEditDialog-formGroup-product-input">
      </div>
      <div class="form-group" id="valuemappingAddEditDialog-formGroup-afdfield">
        <label>{{ 'AFD field' | translate }} <span class="asterisk">*</span></label>
        <input type="text"
               class="form-control form-control-sm"
               v-model="valuemapping.afdField"
               required
               id="valuemappingAddEditDialog-formGroup-afdfield-input">
      </div>
      <div class="form-group" id="valuemappingAddEditDialog-formGroup-afdvalue">
        <label>{{ 'AFD value' | translate }} <span class="asterisk">*</span></label>
        <input type="text"
               class="form-control form-control-sm"
               v-model="valuemapping.afdValue"
               required
               id="valuemappingAddEditDialog-formGroup-afdvalue-input">
      </div>

      <div class="form-group" id="valuemappingTableAddEditDialog-formGroup-apivalueincoming" >
    <label>{{ 'API_VALUE_INCOMING' | translate }}</label>
    <div v-for="(code, index) in valuemapping.apiValueIncoming" :key="index" class="form-group position-relative d-flex align-items-center">
        <input type="text"
              class="form-control form-control-sm"
              v-model="valuemapping.apiValueIncoming[index]"
              @input="updateApiValueIncoming(index, $event.target.value)"
              :id="'valuemappingTableAddEditDialog-apivalueincoming-input-' + index"
              style="flex-grow: 1;">
          <button type="button" @click="removeApiValueIncoming(index)" class="btn btn-danger btn-sm ms-2">
            <i class="fas fa-times"></i>
          </button>
    </div>
  <button class="btn btn-link" type="button" @click="addNewApiValueIncoming">Add New Code</button>
  </div>
      <div class="form-group" id="valuemappingAddEditDialog-formGroup-apivalueoutgoing">
        <label>{{ 'API_VALUE_OUTGOING' | translate }}</label>
        <input type="text"
               class="form-control form-control-sm"
               v-model="valuemapping.apiValueOutgoing"
               id="valuemappingAddEditDialog-formGroup-apivalueoutgoing-input">
      </div>
    
      <div class="mt-4 text-right" id="valuemappingAddEditDialog-formGroup-buttons">
    
        <button class="btn btn-link" type="button"
                @click="emitClose"
                id="valuemappingAddEditDialog-closeButton"
        >{{ 'CLOSE' | translate }}</button>
    
        <button class="btn btn-primary"
                type="submit"
                :disabled="!isFormValid"
                id="valuemappingAddEditDialog-addButton"
        >{{ 'ADD' | translate }}</button>
    
      </div>
    </form>
    </div>
    </template>
    
    <script>
    import GeneralConfigService from '../../../service/GeneralConfigService';
    
    export default {
      props: ['edited', 'errortype'],
      data() {
        return {
          valuemapping: {
            apiValueIncoming: []
          }
        }
      },
      computed: {
        isFormValid() {
          return (this.valuemapping.afdField && this.valuemapping.afdValue);
        }
      },
      methods: {
        emitSave() {
          this.$emit(this.edited ? 'update' : 'save', this.valuemapping);
          if (this.valuemapping.enabled) {
            GeneralConfigService.addOrUpdateEnabledValueMapping(this.valuemapping);
          } else {
            GeneralConfigService.removeEnabledValueMapping(this.valuemapping);
          }
          this.valuemapping = {};
          this.resetValuemapping();
        },
        emitClose() {
          this.$emit('close');
          this.valuemapping = {};
          this.resetValuemapping();
        },
        resetValuemapping() {
          this.valuemapping = { apiValueIncoming: [] };
          this.edited = false;
        },
        updateApiValueIncoming(index, value) {
          this.$set(this.valuemapping.apiValueIncoming, index, value);
        },
        removeApiValueIncoming(index) {
          this.valuemapping.apiValueIncoming.splice(index, 1);
        },
        addNewApiValueIncoming() {
          this.valuemapping.apiValueIncoming.push('');
        }
      },
      watch: {
        edited(newVal) {
          // Merge newVal properties with default structure to avoid undefined issues
          this.valuemapping = {
            apiValueIncoming: newVal.apiValueIncoming || [],
            id: newVal.id || '',
            product: newVal.product || '',
            afdField: newVal.afdField || '',
            afdValue: newVal.afdValue || '',
            apiValueOutgoing: newVal.apiValueOutgoing || ''
          };
        }
      }
    }
    </script>
    
    <style lang="scss" scoped>
    .asterisk {
      color: $danger;
    }
    
    >>> .vdp-datepicker__calendar {
      bottom: 30px;
    }

    .position-relative {
  position: relative;
}

.btn-danger {
  border: none;
  background-color: #dc3545;
  color: white;
  padding: 0.25rem 0.5rem;
}

.btn-danger:hover {
  background-color: #c82333;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.ms-2 {
  margin-left: 0.5rem;
}

.scrollable-container {
  max-height: 500px; 
  overflow-y: auto; 
  border-radius: 4px; 
}
    </style>
    


// WEBPACK FOOTER //
// src/components/admin/valuemapping/ValueMappingAddEditDialog.vue